import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosError, AxiosResponse } from 'axios'
import { useState, useEffect } from 'react'
export interface ajustmentsProps {
  formatedValue: string
  description: string
}
export interface ajustmentsObjectProps {
  data: ajustmentsProps[]
  totalRaw: number
  totalFormated: string
}
export interface FinancialAjustmentsResponseProps {
  success: boolean
  data: {
    adjustmentsObject: ajustmentsObjectProps
  }
}

export interface AjustmentsProps {
  adjustmentsData: ajustmentsProps[]
  adjustmentsFormatedTotal: string
  adjustmentsRawTotal: number
  isLoading: boolean
  isErrorDebits: undefined | AxiosError
}

export interface useFinancialAdjustment {
  financialAjustments:
    | AxiosResponse<FinancialAjustmentsResponseProps>
    | undefined
  isLoadingAjustments: boolean
  isErrorAjustments: AxiosError
}

export const useSWRRequest = (eventId: number): useFinancialAdjustment => {
  const url: string = `producer/analytics/finacialCloseAdjustments?eventId=${eventId}`

  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR(url, fetchData, {
    refreshInterval: 600000,
  })

  return {
    financialAjustments: data,
    isLoadingAjustments: isLoading,
    isErrorAjustments: error,
  }
}

export const useFinancialClosingAdjustments = (eventId: number): any => {
  const [adjustments, setAdjustments] = useState<AjustmentsProps>({
    adjustmentsData: [],
    adjustmentsFormatedTotal: '',
    adjustmentsRawTotal: 0,
    isLoading: true,
    isErrorDebits: undefined,
  })

  const { financialAjustments, isLoadingAjustments, isErrorAjustments } =
    useSWRRequest(eventId)

  useEffect(() => {
    if (financialAjustments !== undefined) {
      const adjustmentsRaw = financialAjustments.data.data
      setAdjustments({
        adjustmentsData: adjustmentsRaw.adjustmentsObject.data,
        adjustmentsFormatedTotal:
          adjustmentsRaw.adjustmentsObject.totalFormated,
        adjustmentsRawTotal: adjustmentsRaw.adjustmentsObject.totalRaw,
        isLoading: isLoadingAjustments,
        isErrorDebits: isErrorAjustments,
      })
    }
  }, [financialAjustments, isLoadingAjustments, isErrorAjustments])

  return { adjustments }
}
